import React, { useCallback } from 'react';
import { Form } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import { Filter } from '../../../Enum/Filters';

import { filterChanged } from '../../../Store/Filter/action';
import useGetFilterValue from '../../../Hook/Interest/UseGetFilterValue';
import useGetPeriods from '../../../Hook/Interest/UseGetPeriods';
import { getIdentifier, getLabel } from '../../../Helpers/Interest/PeriodHelper';

const FixedPeriodFilter: React.FC = () => {
    const dispatch = useDispatch();
    const value = useGetFilterValue(Filter.FixedPeriod);
    const periods = useGetPeriods();

    const selectFixedPeriod = useCallback(
        (fixedPeriod: string): void => {
            dispatch(filterChanged(Filter.FixedPeriod, fixedPeriod));
        },
        [dispatch],
    );

    return (
        <Form className="fixed-period-filter" autoComplete="off">
            <Form.Group controlId="fixed_period">
                <Form.Label>Rentevastperiode</Form.Label>
                <Form.Control
                    as="select"
                    custom
                    value={value as string}
                    onChange={e => selectFixedPeriod(e.currentTarget.value)}
                >
                    {periods.map(period => (
                        <option value={getIdentifier(period)} key={getIdentifier(period)}>
                            {getLabel(period)}
                        </option>
                    ))}
                </Form.Control>
            </Form.Group>
        </Form>
    );
};

export default FixedPeriodFilter;
